import http from './../../../http4.js'


export const getCourseList = data => {
	return http({
		url: '/Courses/HomePageCourseList',
		method: 'get',
		params: {
			...data
		}
	})
};


// 图片验证码

export const GetCaptcha = data => {
	return http({
		url: '/SlidingVer/GetCaptcha',
		method: 'get',
		params: {
			...data
		}
	})
};


// 提交验证

export const CheckCaptcha = data => {
	return http({
		url: '/SlidingVer/CheckCaptcha',
		method: 'post',
		data
	})
};



// 课程详情
export const getCourseListxqdetails = data => {
	return http({
		url: '/Courses/CourseDetails',
		method: 'get',
		params: {
			CO_GUID: data
		}
	})
};


// PublicConditions/GetProfList

// 专业
export const getGetProfList = data => {
	return http({
		url: '/PublicConditions/GetProfList',
		method: 'get',
		params: {}
	})
};



// 岗位
export const getPositionList = data => {
	return http({
		url: '/PublicConditions/GetPositionList',
		method: 'get',
		params: {
			pro_guid: data
		}
	})
};
// 等级
export const getInspectionlevel = data => {
	return http({
		url: '/PublicConditions/GetInspectionlevel',
		method: 'get',
		params: {}
	})
};

// Resource/GetResourceType  资源类型
export const getGetResourceTypes = data => {
	return http({
		url: '/Resource/GetResourceType',
		method: 'get',
		params: {}
	})
};


//  课程进度  /Courses/UpdateStudyProgress
export const UpdateStudyProgress = data => {
	return http({
		url: '/Courses/UpdateStudyProgress',
		method: 'get',
		params: {
			...data
		}
	})
};



// 资源类型
// /PublicConditions/GetResourceType
export const getGetResourceType = data => {
	return http({
		url: '/PublicConditions/GetResourceType',
		method: 'get',
		params: {}
	})
};


// 资源分页
export const getGetPagResourceList = data => {
	return http({
		url: '/Resource/GetPagResourceList',
		method: 'get',
		params: {
			...data
		}
	})
};

// 资源详情
export const getResourceDetails = data => {
	return http({
		url: '/Resource/ResourceDetails',
		method: 'get',
		params: {
			LR_GUID: data
		}
	})
};

// 获取视频  /Resource/GetVideo
export const getVideo = (data, responseType) => {
	return http({
		url: '/Resource/GetVideo',
		method: 'get',
		responseType: responseType || 'json',
		params: {
			path: data
		}
	})
};

// 试题数量  /TestQuestions/GetQusetionsTypeSum
export const getGetQusetionsTypeSum = data => {
	return http({
		url: '/TestQuestions/GetQusetionsTypeSum',
		method: 'get',
		params: {
			...data
		}
	})
};

// /Courses/HomeCourseList  课程列表

export const getHomeCourseList = data => {
	return http({
		url: '/Courses/HomeCourseList',
		method: 'get',
		params: {
			type: data
		}
	})
};

// TestQuestions/AjaxSimulationTraining  模拟考试

export const getAjaxSimulationTraining = data => {
	return http({
		url: '/TestQuestions/AjaxSimulationTraining',
		method: 'get',
		params: {
			...data
		}
	})
};

// TestQuestions/lspapercreaterule  模拟考试

export const IspapercreateruleApi = data => {
	return http({
		url: '/TestQuestions/Ispapercreaterule',
		method: 'get',
		params: {
			...data
		}
	})
};


// 获取题目 随机练习
export const getQuestionRandomTraining = data => {
	return http({
		url: '/TestQuestions/AjaxQuestionRandomTraining',
		method: 'get',
		params: {
			...data
		}
	})
};

// PublicConditions/GetQuetype 题目类型


export const getGetQuetype = data => {
	return http({
		url: '/PublicConditions/GetQuetype',
		method: 'get',
		params: {}
	})
};


// 考试题目

export const getSimulation = data => {
	return http({
		url: '/TestQuestions/AjaxSimulationTraining',
		method: 'get',
		params: {
			...data
		}
	})
};

// 获取试卷




// 提交考试

export const setAjaxScoring = data => {
	return http({
		url: '/TestQuestions/AjaxScoring',
		method: 'post',
		data
	})
};

// 课程接口
// Courses/GetCourseList

export const getGetCourseList = data => {
	return http({
		url: '/Courses/GetCourseList',
		method: 'get',
		params: {
			...data
		}
	})
};


//评论回复 /Course/AddComment
export const changeAddComment = data => {
	return http({
		url: '/Courses/AddComment',
		method: 'post',
		data
	})
};

// 获取二维码  /Courses/GetQRCode

export const getGetQRCode = data => {
	return http({
		url: '/Courses/GetQRCode',
		method: 'get',
		params: {
			...data
		}
	})
};


// 获取评论 /Courses/GetComment
export const getGetComment = data => {
	return http({
		url: '/Courses/GetComment',
		method: 'get',
		params: {
			...data
		}
	})
};



// 修改课程

export const changeUpdateCourser = data => {
	return http({
		url: '/Courses/UpdateCourser',
		method: 'post',
		data
	})
};

//审核

export const changeAuditCousers = data => {
	return http({
		url: '/Courses/AuditCousers',
		method: 'post',
		data
	})
};

// 下架课程
export const changeOffshelfCousers = data => {
	return http({
		url: '/Courses/OffshelfCousers',
		method: 'post',
		data
	})
};

// 上架课程
export const changeOffEnableCousers = data => {
	return http({
		url: '/Courses/EnableCousers',
		method: 'post',
		data
	})
};


//  /Courses/GetChapterAssignmentTitle   查看章节作业
export const GetChapterAssignmentTitle = data => {
	return http({
		url: '/Courses/GetChapterAssignmentTitle',
		method: 'get',
		params: {
			...data
		}
	})
};

//   /Courses/AssignmentSubmission    提交章节作业
export const AssignmentSubmission = data => {
	return http({
		url: '/Courses/AssignmentSubmission',
		method: 'post',
		data
	})
};




// 删除课程

export const changeDeleteCousers = data => {
	return http({
		url: '/Courses/DeleteCousers',
		method: 'post',
		data
	})
};


//查询课程申请列表

export const changeGetListreview = data => {
	return http({
		url: '/Courses/GetListreview',
		method: 'get',
		params: {
			...data
		}
	})
};


// 审核课程申请

export const changeAuditCousersReview = data => {
	return http({
		url: '/Courses/AuditCousersReview',
		method: 'post',
		data: data
	})
};

// 推荐最热最新
export const changeMarkasRecommended = data => {
	return http({
		url: '/Courses/MarkasRecommended',
		method: 'post',
		data
	})
};

//  添加课程

export const changeAddCourse = data => {
	return http({
		url: '/Courses/AddCourse',
		method: 'post',
		data
	})
};

// 查看课程详情


export const LookCourserDetails = data => {
	return http({
		url: '/Courses/CourserDetails',
		method: 'get',
		params: {
			...data
		}
	})
};


//  上传资源返回url

export const changeUploadFileAsync = data => {
	return http({
		url: '/Courses/UploadFileAsync',
		method: 'post',
		data
	})
};


/* 岗位 */

// /Station/Get  岗位列表


export const getStation = data => {
	return http({
		url: '/Station/Get',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /Station/Delete 删除岗位

export const getDeleteStation = data => {
	return http({
		url: '/Station/Delete',
		method: 'get',
		params: {
			...data
		}
	})
};

// 修改岗位

export const changeStationUpdate = data => {
	return http({
		url: '/Station/Update',
		method: 'post',
		data
	})
};

///Station/Add  新增岗位
export const changeStationAdd = data => {
	return http({
		url: '/Station/Add',
		method: 'post',
		data
	})
};

// KonwledgeType/Get  实训类别

export const changeKonwledgeType = data => {
	return http({
		url: '/KonwledgeType/Get',
		method: 'get',
		params: {
			...data
		}
	})
};

///KonwledgeType/Delete 删除类别
export const changeTypeDelete = data => {
	return http({
		url: '/KonwledgeType/Delete',
		method: 'get',
		params: {
			...data
		}
	})
};

// /KonwledgeType/Update  修改类别
export const changeTypeUpdate = data => {
	return http({
		url: '/KonwledgeType/Update',
		method: 'post',
		data
	})
};


//  /Station/Add  添加类别
export const changeTypeAdd = data => {
	return http({
		url: '/KonwledgeType/Add',
		method: 'post',
		data
	})
};


// /Grade/Get  查询等级
export const changeGradeGet = data => {
	return http({
		url: '/Grade/Get',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /Grade/Delete  删除等级

export const changeGradeDelete = data => {
	return http({
		url: '/Grade/Delete',
		method: 'get',
		params: {
			...data
		}
	})
};


// /Grade/Update  修改等级

export const changeGradeUpdate = data => {
	return http({
		url: '/Grade/Update',
		method: 'post',
		data
	})
};


//  /Grade/Add  新增等级

export const changeGradeAdd = data => {
	return http({
		url: '/Grade/Add',
		method: 'post',
		data
	})
};


// /Courses/GetCourseCatalog  课程详情  

export const GetCourseCatalog = data => {
	return http({
		url: '/Courses/GetCourseCatalog',
		method: 'get',
		params: {
			...data
		}
	})
};


// 资源管理 /Resource/GetResourceList


export const getResourceList = data => {
	return http({
		url: '/Resource/GetResourceList',
		method: 'get',
		params: {
			...data
		}
	})
};

// /Resource/ResourceReview  审核资源
export const ResourceReview = data => {
	return http({
		url: '/Resource/ResourceReview',
		method: 'post',
		data
	})
};
// /Resource/DeleteResource  删除资源
export const DeleteResource = data => {
	return http({
		url: '/Resource/DeleteResource',
		method: 'post',
		data
	})
};

// /Resource/UpdateResourceType  修改资源类型
export const UpdateResourceType = data => {
	return http({
		url: '/Resource/UpdateResourceType',
		method: 'post',
		data
	})
};


// /Resource/AddResourceType  增加资源类型
export const AddResource = data => {
	return http({
		url: '/Resource/AddResourceType',
		method: 'post',
		data
	})
};

// 上传文件 /Courses/UploadFileAsync

export const UploadFileAsync = data => {
	return http({
		url: '/Courses/UploadFileAsync',
		method: 'post',
		data
	})
};


//  新增资源 /Resource/AddResource
export const AddResourcesource = data => {
	return http({
		url: '/Resource/AddResource',
		method: 'post',
		data
	})
};
// 修改资源
export const UpdateResourcea = data => {
	return http({
		url: '/Resource/UpdateResource',
		method: 'post',
		data
	})
};



//  资源详情 /Resource/ResourceDetails
export const ResourceDetails = data => {
	return http({
		url: '/Resource/ResourceDetails',
		method: 'get',
		params: {
			...data
		}
	})
};


// /Message/GetPageMessageList   消息分页

export const GetPageMessageList = data => {
	return http({
		url: '/Message/GetPageMessageList',
		method: 'get',
		params: {
			...data
		}
	})
};



// /TestQuestions/GetTrainingStrategyList    策略

export const GetTrainingStrategyList = data => {
	return http({
		url: '/TestQuestions/GetTrainingStrategyList',
		method: 'get',
		params: {
			...data
		}
	})
};



//   /TestQuestions/AddTrainingStrategy  新增策略

export const AddTrainingStrategy = data => {
	return http({
		url: '/TestQuestions/AddTrainingStrategy',
		method: 'post',
		data
	})
};

//   /TestQuestions/GetQuestionList   查询题库列表


export const GetQuestionList = data => {
	return http({
		url: '/TestQuestions/GetQuestionList',
		method: 'get',
		params: {
			...data
		}
	})
};


// /TestQuestions/EnableTrainingStrategy   启用训练策略

export const EnableTrainingStrategy = data => {
	return http({
		url: '/TestQuestions/EnableTrainingStrategy',
		method: 'post',
		data
	})
};


//  /TestQuestions/DisableTrainingStrategy 禁用

export const DisableTrainingStrategy = data => {
	return http({
		url: '/TestQuestions/DisableTrainingStrategy',
		method: 'post',
		data
	})
};


// /TestQuestions/DeleteTrainingStrategy  删除策略
export const DeleteTrainingStrategy = data => {
	return http({
		url: '/TestQuestions/DeleteTrainingStrategy',
		method: 'post',
		data
	})
};

//   /TestQuestions/TrainingStrategyDetails   查询策略详情
export const TrainingStrategyDetails = data => {
	return http({
		url: '/TestQuestions/TrainingStrategyDetails',
		method: 'get',
		params: {
			...data
		}
	})
};

// /TestQuestions/UpdateTrainingStrategy  修改策略
export const UpdateTrainingStrategy = data => {
	return http({
		url: '/TestQuestions/UpdateTrainingStrategy',
		method: 'post',
		data
	})
};


//  /TestQuestions/QuestionAdd 添加试题
export const QuestionAdd = data => {
	return http({
		url: '/TestQuestions/QuestionAdd',
		method: 'post',
		data
	})
};


// /TestQuestions/DeleteQuestion  删除试题
export const DeleteQuestion = data => {
	return http({
		url: '/TestQuestions/DeleteQuestion',
		method: 'post',
		data
	})
};

// 获取单个试题  /TestQuestions/QuestionDetails

export const QuestionDetails = data => {
	return http({
		url: '/TestQuestions/QuestionDetails',
		method: 'get',
		params: {
			...data
		}
	})
};

//  修改试题  /TestQuestions/UpdateQuestion


export const UpdateQuestion = data => {
	return http({
		url: '/TestQuestions/UpdateQuestion',
		method: 'post',
		data
	})
};

//   /TestQuestions/GetTestPaperList   查询考试列表

export const GetTestPaperList = data => {
	return http({
		url: '/TestQuestions/GetTestPaperList',
		method: 'get',
		params: {
			...data
		}
	})
};

//   /TestQuestions/UserPerlist   查询考试列表

export const UserPerlist = data => {
	return http({
		url: '/TestQuestions/UserPerlist',
		method: 'get',
		params: {
			...data
		}
	})
};


// 消息  

export const GetPageMessageLists = data => {
	return http({
		url: '/Message/GetPageMessageList',
		method: 'get',
		params: {
			...data
		}
	})
};


// 删除消息

export const MessageDelete = data => {
	return http({
		url: '/Message/Delete',
		method: 'post',
		data
	})
};


// 试卷详情 /TestQuestions/UserPerDetails

export const UserPerDetails = data => {
	return http({
		url: '/TestQuestions/UserPerDetails',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /TestQuestions/ImportQuestion   批量新增
export const ImportQuestion = data => {
	return http({
		url: '/TestQuestions/ImportQuestion',
		method: 'post',
		data
	})
};


//  消息类型

export const GetMessagetypeList = data => {
	return http({
		url: '/Message/GetMessagetypeList',
		method: 'get',
		params: {
			...data
		}
	})
};

// 删除消息类型 /Message/DeleteMessagetype
export const DeleteMessagetype = data => {
	return http({
		url: '/Message/DeleteMessagetype',
		method: 'post',
		data
	})
};




// 添加消息类型 /Message/AddMessagetype
export const AddMessagetype = data => {
	return http({
		url: '/Message/AddMessagetype',
		method: 'post',
		data
	})
};


// 修改消息类型 /Message/UpdateMessagetype
export const UpdateMessagetype = data => {
	return http({
		url: '/Message/UpdateMessagetype',
		method: 'post',
		data
	})
};


//  查看消息  /apiMessage/MessageDetails
export const MessageDetails = data => {
	return http({
		url: '/Message/MessageDetails',
		method: 'get',
		params: {
			...data
		}
	})
};


// 添加消息 /Message/Add
export const MessageAdd = data => {
	return http({
		url: '/Message/Add',
		method: 'post',
		data
	})
};


// 添加富文本图片  

export const MessageUploadFile = data => {
	return http({
		url: '/Message/UploadFile',
		method: 'post',
		data
	})
};

// 修改消息  /Message/Update

export const MessageUpdate = data => {
	return http({
		url: '/Message/Update',
		method: 'post',
		data
	})
};


// 删除试卷    /TestQuestions/DeletePaper

export const DeletePaper = data => {
	return http({
		url: '/TestQuestions/DeletePaper',
		method: 'post',
		data
	})
};

// 查看预览试卷

export const PaperDetailsjs = data => {
	return http({
		url: '/TestQuestions/PaperDetails',
		method: 'get',
		params: {
			...data
		}
	})
};

// /TestQuestions/SpaUserlist 查看详情试卷

export const SpaUserlist = data => {
	return http({
		url: '/TestQuestions/SpaUserlist',
		method: 'get',
		params: {
			...data
		}
	})
};


//  派卷  /TestQuestions/PjPaper
export const PjPaperTestQuestions = data => {
	return http({
		url: '/TestQuestions/PjPaper',
		method: 'post',
		data
	})
};

//  /ClassInfo/GetClassList   获取班级列表

export const GetClassList = data => {
	return http({
		url: '/ClassInfo/GetClassList',
		method: 'get',
		params: {
			...data
		}
	})
};

// 添加试卷 自由组卷  /TestQuestions/zAddPaper

export const zAddPaperTestQuestions = data => {
	return http({
		url: '/TestQuestions/zAddPaper',
		method: 'post',
		data
	})
};


//  添加试卷 随机组卷  /TestQuestions/AddPaper

export const AddPaperTestQuestions = data => {
	return http({
		url: '/TestQuestions/AddPaper',
		method: 'post',
		data
	})
};

//  修改试卷 随机组卷  /TestQuestions/UpdatePaper

export const UpdatePaperTest = data => {
	return http({
		url: '/TestQuestions/UpdatePaper',
		method: 'post',
		data
	})
};

//  修改试卷 自由组卷  /TestQuestions/UpdatePaper

export const zUpdatePaperTest = data => {
	return http({
		url: '/TestQuestions/UpdatePaper',
		method: 'post',
		data
	})
};

// 添加地图 /LearningMaps/Addmap
export const AddmapLearningMaps = data => {
	return http({
		url: '/LearningMaps/Addmap',
		method: 'post',
		data
	})
};

// 分配地图

export const DistributionMap = data => {
	return http({
		url: '/LearningMaps/DistributionMap',
		method: 'post',
		data
	})
};


//  学校不分页 /School/GetSchoolList
export const GetSchoolList = data => {
	return http({
		url: '/School/GetSchoolList',
		method: 'get',
		params: {
			...data
		}
	})
};


//  /ClassInfo/GetPageClassList  班级列表
export const GetPageClassLists = data => {
	return http({
		url: '/ClassInfo/GetPageClassList',
		method: 'get',
		params: {
			...data
		}
	})
};


//  /LearningMaps/MapList  地图列表
export const MapListLearningMaps = data => {
	return http({
		url: '/LearningMaps/MapList',
		method: 'get',
		params: {
			...data
		}
	})
};


export const getTrainRoom = data => {
	return http({
		url: '/Train/GetPageTrainList',
		method: 'get',
		params: {
			...data
		}
	})
};



// /LearningMaps/Deletemap  删除地图


export const DeletemapLearningMaps = data => {
	return http({
		url: '/LearningMaps/Deletemap',
		method: 'post',
		data
	})
};

// /LearningMaps/LearnmapDetails 获取地图详情

export const LearnmapDetails = data => {
	return http({
		url: '/LearningMaps/LearnmapDetails',
		method: 'get',
		params: {
			...data
		}
	})
};


//  /LearningMaps/UpdateLearnmap  修改地图

export const UpdateLearnmap = data => {
	return http({
		url: '/LearningMaps/UpdateLearnmap',
		method: 'post',
		data
	})
};


//   /LearningMaps/MapUserList   获取地图用户详情
export const MapUserList = data => {
	return http({
		url: '/LearningMaps/MapUserList',
		method: 'get',
		params: {
			...data
		}
	})
};

//   /QuestionBank/GetUserSentPaper   我的考试
export const GetUserSentPaper = data => {
	return http({
		url: '/TestQuestions/thisUserPer',
		method: 'get',
		params: {
			...data
		}
	})
};


// /TestQuestions/GetDate  获取时间
export const GetDate = data => {
	return http({
		url: '/TestQuestions/GetDate',
		method: 'get',
		params: {
			...data
		}
	})
};

// /Courses/MyCourse  查询我的课程
export const MyCourses = data => {
	return http({
		url: '/Courses/MyCourse',
		method: 'get',
		params: {
			...data
		}
	})
};


// 查询新的我的课程 /Courses/GetWroteList
export const GetCollectWroteList = data => {
	return http({
		url: '/Courses/GetWroteList',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /my/ColCourse  收藏课程
export const ColCourse = data => {
	return http({
		url: '/Courses/ColCourse',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /Courses/ApplyCourse  申请加入课程
export const ApplyCourse = data => {
	return http({
		url: '/Courses/ApplyCourse',
		method: 'get',
		params: {
			...data
		}
	})
};


// guidList /my/DelColCourse
export const DelColCourse = data => {
	return http({
		url: '/my/DelColCourse',
		method: 'post',
		data
	})
};


//  收藏题目 /TestQuestions/AddMyCollect
export const AddMyCollects = data => {
	return http({
		url: '/TestQuestions/AddMyCollect',
		method: 'get',
		params: {
			...data
		}
	})
};


// 删除题目收藏
export const DeleteMyCollect = data => {
	return http({
		url: '/TestQuestions/DeleteMyCollect',
		method: 'get',
		params: {
			...data
		}
	})
};

// 删除我的错题  /TestQuestions/DeleteCollectwrote

export const DeleteCollectwrote = data => {
	return http({
		url: '/TestQuestions/DeleteCollectwrote',
		method: 'get',
		params: {
			...data
		}
	})
};

// 收藏课程列表  /Courses/GetCollectWroteList
export const GetCollectWroteLists = data => {
	return http({
		url: '/Courses/GetCollectWroteList',
		method: 'get',
		params: {
			...data
		}
	})
};

//  /TestQuestions/GetMyCollectList  获取收藏题目
export const GetMyCollectList = data => {
	return http({
		url: '/TestQuestions/GetMyCollectList',
		method: 'get',
		params: {
			...data
		}
	})
};

// /Courses/DelColCourse  删除 
export const DelColCourses = data => {
	return http({
		url: '/Courses/DelColCourses',
		method: 'get',
		params: {
			...data
		}
	})
};


// TestQuestions/KsScoring 正式提交
export const KsScoringTestQuestions = data => {
	return http({
		url: '/TestQuestions/KsScoring',
		method: 'post',
		data
	})
};


//  /LearningMaps/MapTrendsList   学习动态

export const MapTrendsLists = data => {
	return http({
		url: '/LearningMaps/MapTrendsList',
		method: 'get',
		params: {
			...data
		}
	})
};


// /user/FaceLogin  人脸登录
export const FaceLoginuser = data => {
	return http({
		url: '/user/FaceLogin',
		method: 'post',
		data
	})
};


// 我的笔记
export const GetMYPaperNotes = data => {
	return http({
		url: '/TestQuestions/GetMYPaperNotes',
		method: 'get',
		params: {
			...data
		}
	})
};


// 移除笔记
export const DeletePnTest = data => {
	return http({
		url: '/TestQuestions/DeletePn',
		method: 'post',
		data
	})
};


// 移除笔记
export const GetMYCourseNotes = data => {
	return http({
		url: '/TestQuestions/GetMYCourseNotes',
		method: 'get',
		params: {
			...data
		}
	})
};


// 导出题库 
export const ExportToExcels = data => {
	return http({
		url: '/TestQuestions/ExportToExcel',
		method: 'get',
		params: {
			...data
		},
		responseType: 'blob'
	})
};


// 添加考核任务 
export const AddJxPaper = data => {
	return http({
		url: '/JX/AddJxPaper',
		method: 'post',
		data
	})
};


// 报名 
export const Application = data => {
	return http({
		url: '/JX/Application',
		method: 'post',
		data
	})
};

// 获取任务列表
export const GetUserJxlist = data => {
	return http({
		url: '/JX/GetUserJx',
		method: 'get',
		params: {
			...data
		},
	})
};


// 获取1+X任务动态
export const GetJxTrendslist = data => {
	return http({
		url: '/JX/GetJxTrendslist',
		method: 'get',
		params: {
			...data
		},
	})
};

// 获取1+X任务详情
export const GetJxPaperDetail = data => {
	return http({
		url: '/JX/GetJxPaperDetail',
		method: 'get',
		params: {
			...data
		},
	})
};

// 获取1+X任务列表
export const GetJxPaperList = data => {
	return http({
		url: '/JX/GetJxPaperList',
		method: 'get',
		params: {
			...data
		}
	})
};


// 能力模型列表
export const GetGtsxAbilitymodeltbllist = data => {
	return http({
		url: '/Model/GetGtsxAbilitymodeltbllist',
		method: 'get',
		params: {
			...data
		}
	})
};
// 新增模型
export const PostGtsxAbilitymodeltbl = data => {
	return http({
		url: '/Model/PostGtsxAbilitymodeltbl',
		method: 'post',
		data
	})
};

// 新增模型内容
export const PostGtSxAbilityType = data => {
	return http({
		url: '/Model/PostGtSxAbilityType',
		method: 'post',
		data
	})
};

// 删除模型
export const DeleteGtsxAbilitymodeltbl = data => {
	return http({
		url: '/Model/DeleteGtsxAbilitymodeltbl',
		method: 'post',
		data
	})
};

// 获取模型详情
export const GtsxAbilitymodeltbl = data => {
	return http({
		url: '/Model/GtsxAbilitymodeltbl',
		method: 'get',
		params: {
			...data
		}
	})
};



// 修改模型
export const UpdateGtsxAbilitymodeltbl = data => {
	return http({
		url: '/Model/UpdateGtsxAbilitymodeltbl',
		method: 'post',
		data
	})
};

// 绑定模型
export const DeviceOrAbility = data => {
	return http({
		url: '/Model/DeviceOrAbility',
		method: 'post',
		data
	})
};


// 查询设备

export const GettrainingEquipment = data => {
	return http({
		url: '/Model/GettrainingEquipment',
		method: 'get',
		params: {
			...data
		}
	})
};


// 查询试卷列表
export const GetPaperlistApi = data => {
	return http({
		url: '/Model/GetPaperlist',
		method: 'get',
		params: {
			...data
		}
	})
};

// 设备绑定试卷
export const PaperOrAbility = data => {
	return http({
		url: '/Model/PaperOrAbility',
		method: 'post',
		data
	})
};

// 取消试卷绑定  
export const DeletePaperorability = data => {
	return http({
		url: '/Model/DeletePaperorability',
		method: 'post',
		data
	})
};


// 删除类型

export const DeleteAbilityType = data => {
	return http({
		url: '/Model/DeleteAbilityType',
		method: 'post',
		data
	})
};

// 新增类型
export const PostAbilityType = data => {
	return http({
		url: '/Model/PostAbilityType',
		method: 'post',
		data
	})
};

// 修改类型
export const UpdateAbilityType = data => {
	return http({
		url: '/Model/UpdateAbilityType',
		method: 'post',
		data
	})
};

// 新增模型项目
export const PostAbilityNexusInfo = data => {
	return http({
		url: '/Model/PostAbilityNexusInfo',
		method: 'post',
		data
	})
};
//  修改模型项目 
export const UpdateAbilityTypenexus = data => {
	return http({
		url: '/Model/UpdateAbilityNexusInfo',
		method: 'post',
		data
	})
};



// 删除模型项目
export const DeleteAbilityNexusInfo = data => {
	return http({
		url: '/Model/DeleteAbilityNexusInfo',
		method: 'post',
		data
	})
};


// 个人实训档案

// 实训档案综合能力评估  
export const GetMyTrainDataApi = data => {
	return http({
		url: '/Model/GetMyTrainData',
		method: 'get',
		params: {
			...data
		}
	})
};


// 实训档案实训数据统计 
export const GetMyTrainResultsApi = data => {
	return http({
		url: '/Model/GetMyTrainResults',
		method: 'get',
		params: {
			...data
		}
	})
};


// 个人统计 实训数据统计 
export const GetMyTrainResultsModelApi = data => {
	return http({
		url: '/Model/GetMyTrainResults',
		method: 'get',
		params: {
			...data
		}
	})
};


// 个人综合能力 评估 /Model/GetMyComprehensiveSTA
export const GetMyComprehensiveSTAApi = data => {
	return http({
		url: '/Model/GetMyComprehensiveSTA',
		method: 'get',
		params: {
			...data
		}
	})
};








